<template>
  <div class="system-simulation-payment">
    <el-card class="box-card">
      <div class="text item">
        <el-form ref="form" :model="search" label-width="150px" label-position="left">
          <el-form-item :label="$t('system.mch_order_id')" prop="mch_order_id" required>
            <el-input
              v-model="search.mch_order_id"
              size="small"
              :placeholder="$t('system.mch_order_id')"
              class="search-frame"
              autocomplete="off"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('merchantAccount.transaction_status')" prop="transaction_status" required>
            <el-select v-model="search.transaction_status" class="search-frame" size="small" clearable>
              <el-option
                v-for="(item,index) in payTransactionStatusArr"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="listLoading" @click="onSubmit('form')">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { simulationDisbursement } from '@/api/system/system'
import { simulatePayTransactionStatusMap } from '@/utils/maps'
import i18n from "@/lang";

export default {
  name: 'System_simulation_dynamic_payment',
  data() {
    return {
      listLoading: false,
      search: {
        mch_order_id: '',
        transaction_status: ''
      }
    }
  },
  computed: {
    payTransactionStatusArr() {
      return [{
        value: 3,
          label: i18n.t('map.pay_trans_status_2'),
        type: 'success'
      },
      {
        value: 4,
          label: i18n.t('map.pay_trans_status_3'),
        type: ''
      }]
    }
  },
  mounted() {

  },
  methods: {
    onSubmit(formName) {
      this.listLoading = true
      simulationDisbursement(this.search).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.search.amount = 0
        }
      }).finally(() => {
        this.listLoading = false
      })
    }
  }
}
</script>

<style scoped>
.search-frame {
  width: 300px;
}

.system-simulation-payment {
  margin: 20px;
  background-color: #fff;
}
</style>
